import styled, { css } from 'styled-components';
import { T as Text } from '../Text/Text-Cv6a53CC.js';
import { L as LABEL_PLACEMENT, S as STATUS } from './constants-uDs2MwW8.js';

const tailStyles = /*#__PURE__*/css(["content:'';height:2px;display:block;top:50%;top:calc(50% - 1px);opacity:1;border-radius:1px;left:100%;inset-inline-start:100%;"]);
const StepTail = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30054544__sc-tnk4bf-0"
})(["", " ", ""], ({
  $labelPlacement,
  theme
}) => $labelPlacement === LABEL_PLACEMENT.VERTICAL ? css(["position:absolute;padding:", ";top:", ";left:50%;inset-inline-start:50%;right:-50%;inset-inline-end:-50%;[dir=\"rtl\"] &&{right:50%;inset-inline-start:50%;left:-50%;inset-inline-end:-50%;}::after{", " background:", ";}"], theme.steps.verticalLabelTailPadding, theme.steps.verticalLabelTailTop, tailStyles, theme.steps.tailColor) : '', ({
  $isVertical,
  theme
}) => $isVertical && css(["background:", ";width:2px;position:relative;left:9px;inset-inline-start:9px;right:auto;inset-inline-end:auto;[dir=\"rtl\"] &&{right:9px;inset-inline-start:9px;left:auto;inset-inline-end:auto;}"], theme.steps.tailColor));
const Circle = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30054544__sc-tnk4bf-1"
})(["width:", ";height:", ";text-align:center;display:inline-block;position:relative;flex:1;", " ", ""], ({
  theme
}) => theme.steps.circleSize, ({
  theme
}) => theme.steps.circleSize, ({
  $labelPlacement,
  theme
}) => $labelPlacement === LABEL_PLACEMENT.VERTICAL ? `
    margin-inline-end: 0;
    ` : `
      margin-inline-end: ${theme.steps.circleSpacing};
    `, ({
  $isVertical,
  theme
}) => $isVertical && css(["flex:none;z-index:1;background:white;margin-inline-start:0;padding-bottom:", "px;"], theme.spacingValues.xlarge));
const getCircleBackgroundColor = (status, theme) => {
  switch (status) {
    case STATUS.COMPLETED:
    case STATUS.ACTIVE:
      return theme.steps.circleBackgroundColorCompleted;
    case STATUS.FUTURE:
    case STATUS.DISABLED:
    default:
      return theme.steps.circleBackgroundColorFuture;
  }
};
const getCircleBackgroundOpacity = (status, theme) => {
  switch (status) {
    case STATUS.FUTURE:
      return theme.steps.circleBackgroundOpacityFuture;
    case STATUS.DISABLED:
      return theme.steps.circleBackgroundOpacityDisabled;
    default:
      return theme.steps.circleBackgroundOpacityDefault;
  }
};
const CircleBackground = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30054544__sc-tnk4bf-2"
})(["width:", ";height:", ";border-radius:", ";position:absolute;top:0;background-color:", ";opacity:", ";"], ({
  theme
}) => theme.steps.circleSize, ({
  theme
}) => theme.steps.circleSize, ({
  theme
}) => theme.steps.circleSize, ({
  $status,
  theme
}) => getCircleBackgroundColor($status, theme), ({
  $status,
  theme
}) => getCircleBackgroundOpacity($status, theme));
const getCircleContentColor = (status, theme) => {
  switch (status) {
    case STATUS.COMPLETED:
    case STATUS.ACTIVE:
      return theme.steps.circleContentColorCompleted;
    case STATUS.FUTURE:
    case STATUS.DISABLED:
    default:
      return theme.steps.circleContentColorFuture;
  }
};
const CircleContent = /*#__PURE__*/styled(Text).attrs({
  type: 'span'
}).withConfig({
  componentId: "sc-storm-ui-30054544__sc-tnk4bf-3"
})(["font-size:", ";position:absolute;opacity:1;z-index:1;color:", ";display:", ";top:", ";left:", ";vertical-align:top;"], ({
  theme
}) => theme.steps.circleContentSize, ({
  $status,
  theme
}) => getCircleContentColor($status, theme), props => props.$status === 'disabled' ? 'none' : 'inherit', ({
  $contentType,
  theme
}) => $contentType === 'icon' ? theme.steps.circleIconTop : theme.steps.circleContentTop, ({
  $contentType,
  theme
}) => $contentType === 'icon' ? theme.steps.circleIconLeft : theme.steps.circleContentLeft);
const ContentWrapper = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30054544__sc-tnk4bf-4"
})(["vertical-align:top;position:relative;flex:1;", ""], ({
  $labelPlacement,
  theme,
  $isVertical
}) => $labelPlacement === LABEL_PLACEMENT.VERTICAL ? `
      display: block;
      text-align: center;
      top: ${theme.steps.verticalLabelContentTop}
    ` : !$isVertical && css(["display:inline-block;margin-top:-1px;::after{width:1000px;background:", ";position:absolute;margin-inline-start:", ";", "}"], theme.steps.tailColor, theme.steps.stepSpacing, tailStyles));
const TitleWrapper = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30054544__sc-tnk4bf-5"
})(["color:", ";color:", ";font-weight:", ";"], ({
  theme
}) => theme.steps.titleColor, ({
  $status,
  theme
}) => $status === STATUS.DISABLED ? theme.steps.titleColorDisabled : theme.steps.titleColor, ({
  $status,
  theme
}) => $status === STATUS.ACTIVE ? theme.steps.titleFontWeightActive : theme.steps.titleFontWeightDefault);
const StepWrapper = /*#__PURE__*/styled('li').withConfig({
  componentId: "sc-storm-ui-30054544__sc-tnk4bf-6"
})(["list-style-type:none;flex:1;position:relative;:last-child ", "::after{display:none;}:last-child ", "::after{display:none;}", " ", ""], Circle, StepTail, ({
  $isVertical,
  theme
}) => $isVertical && css(["display:flex;flex-direction:row;align-content:flex-start;:last-child ", "{background:none;}padding-top:", ";"], StepTail, theme.steps.stepSpacing), ({
  $labelPlacement,
  theme
}) => $labelPlacement === LABEL_PLACEMENT.VERTICAL ? `
      overflow: visible;
      text-align: center;
    ` : `
      overflow: hidden;
      margin-right: ${theme.steps.stepSpacing};
      :last-child {
        flex: none;
      }
    `);

export { Circle as C, StepWrapper as S, TitleWrapper as T, StepTail as a, CircleBackground as b, ContentWrapper as c, CircleContent as d };
//# sourceMappingURL=Step.styles-BUIk6KuD.js.map
